import API_PUBLIC_SERVICE from './http';

const PREFIX = 'warranties';
const pagePath = '/warranty';
const pagesRoute = {
  editPage: val => `${pagePath}/edit/${val}/`,
  addPage: () => `${pagePath}/add/`,
  listPage: () => `${pagePath}/list/`
};
const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'code',
      key: 'code',
      disablePadding: false,
      numeric: false,
      label: 'Código'
    },
    {
      id: 'name',
      key: 'name',
      disablePadding: false,
      numeric: false,
      label: 'Nombre'
    },
    {
      id: '_id',
      key: '_id',
      disablePadding: false,
      numeric: false,
      label: 'Acciones',
      actions: pagesRoute
    }
  ],
  getKeyTable: () => '_id',
  makeDataTable: value => value,
  hasAddOption: true,
  hasCheckbox: false,
  isAdvancedDateFilter: false
};
const path = PREFIX;

const WarrantyService = {
  ...API_PUBLIC_SERVICE,
  ...tableData,
  ...pagesRoute,
  path
};

export default WarrantyService;
